import { useEffect, useState } from "react";
import api from "../api";

const fmt = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString("it-IT"); } catch { return "—"; }
};

export default function Consents() {
  const [list, setList] = useState([]);
  const [reg, setReg] = useState([]);
  const [dels, setDels] = useState([]); // eslint-disable-line no-unused-vars

  useEffect(() => {
    api.get("/persons/consents").then((r) => setList(r.data)).catch(() => {});
    api.get("/optin/consent-registry").then((r) => setReg(r.data)).catch(() => {});
    api.get("/pipeline/deletion-log/all").then((r) => setDels(r.data)).catch(() => {});
  }, []);

  const fmtDT = (iso) => {
    if (!iso) return "—";
    try { return new Date(iso).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short", timeZone: "Europe/Rome" }); } catch { return "—"; }
  };

  const print = () => {
    const rows = list.map((p) => `<tr>
      <td>${p.last_name || ""} ${p.first_name || ""}</td>
      <td>${p.company || ""}</td>
      <td>${p.email || ""}</td>
      <td>${p.phone || ""}</td>
      <td>${fmt(p.privacy_date)}</td>
      <td>${p.privacy_source || ""}</td>
    </tr>`).join("");
    const w = window.open("", "_blank");
    w.document.write(`<html><head><title>Consensi privacy</title>
      <style>body{font-family:Arial,sans-serif;padding:24px;}h1{font-size:18px;}
      table{width:100%;border-collapse:collapse;}th,td{border:1px solid #ccc;padding:6px 8px;text-align:left;font-size:13px;}
      th{background:#f1f5f9;}</style></head><body>
      <h1>Elenco consensi privacy — CRM Silvia Casali</h1>
      <p>Generato il ${new Date().toLocaleString("it-IT")} — ${list.length} persone</p>
      <table><thead><tr><th>Nome</th><th>Azienda</th><th>Email</th><th>Cellulare</th><th>Data consenso</th><th>Origine</th></tr></thead>
      <tbody>${rows}</tbody></table></body></html>`);
    w.document.close();
    w.print();
  };

  return (
    <div>
      <h1 className="page-title">Consensi privacy</h1>
      <p className="page-sub">Persone che hanno accettato l'inserimento nel CRM e l'invio di email e materiali</p>

      <div className="toolbar">
        <span className="muted">{list.length} persone con consenso</span>
        <div className="spacer" />
        <button className="btn primary" onClick={print} disabled={list.length === 0}>Stampa elenco</button>
      </div>

      <div className="panel">
        {list.length === 0 ? <p className="empty">Nessun consenso registrato.</p> : (
          <table>
            <thead><tr><th>Nome</th><th>Azienda</th><th>Email</th><th>Cellulare</th><th>Data</th><th>Origine</th></tr></thead>
            <tbody>
              {list.map((p) => (
                <tr key={p.id}>
                  <td>{p.last_name} {p.first_name}</td>
                  <td>{p.company || <span className="muted">—</span>}</td>
                  <td>{p.email || <span className="muted">—</span>}</td>
                  <td>{p.phone || <span className="muted">—</span>}</td>
                  <td>{fmt(p.privacy_date)}</td>
                  <td>{p.privacy_source || <span className="muted">—</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      <div className="panel" data-testid="consent-registry-panel">
        <h3>🧾 Registro consensi dal questionario check-up</h3>
        <p className="muted" style={{ fontSize: 12, marginTop: 0 }}>
          Record immutabili raccolti dal sito: testi esatti mostrati all'utente, momento della raccolta (ora italiana) e informativa. Registrati sia i consensi accettati sia quelli rifiutati.
        </p>
        {reg.length === 0 ? <p className="empty">Nessun record nel registro.</p> : (
          <table>
            <thead><tr><th>Raccolto il</th><th>Contatto</th><th>Privacy</th><th>Marketing</th><th>Fonte</th><th>Informativa</th></tr></thead>
            <tbody>
              {reg.map((r, i) => (
                <tr key={i} data-testid={`consent-reg-row-${i}`}>
                  <td style={{ whiteSpace: "nowrap" }}>{fmtDT(r.raccolto_il || r.registrato_il)}</td>
                  <td>{r.nome ? <><strong>{r.nome}</strong>{r.azienda ? ` · ${r.azienda}` : ""}<br /></> : null}{r.email}</td>
                  <td title={r.privacy_testo || ""}>{r.privacy === true ? "✅ Sì" : r.privacy === false ? "❌ No" : "—"}</td>
                  <td title={r.marketing_testo || ""}>{r.marketing === true ? "✅ Sì" : r.marketing === false ? "❌ No" : "—"}</td>
                  <td className="muted" style={{ fontSize: 12 }}>{r.fonte || "—"}</td>
                  <td className="muted" style={{ fontSize: 12 }}>{r.informativa ? <a href={r.informativa} target="_blank" rel="noreferrer">apri</a> : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <p className="muted" style={{ fontSize: 11, marginBottom: 0 }}>Passa il mouse su Sì/No per leggere il testo esatto del consenso mostrato all'utente.</p>
      </div>
    </div>
  );
}
